import { render, staticRenderFns } from "./PhoneAndAddress.vue?vue&type=template&id=32a145a4&scoped=true&"
import script from "./PhoneAndAddress.vue?vue&type=script&lang=js&"
export * from "./PhoneAndAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a145a4",
  null
  
)

export default component.exports